<template>
  <section class="low-results" :class="{ desktop: $isDesktop }">
    <translate tag="h3">
      Let us help you find more search results...
    </translate>
    <low-results-city-search
      v-if="isCitySearch"
      :city-name="cityName"
      :area="searchFilters.area"
      @click="scrollTop"
    />
    <low-results-point
      v-if="isPointSearch && !isCitySearch"
      :area="searchFilters.area"
      @click="scrollTop"
    />
    <low-results-hierarchy
      v-if="isHierarchySearch && lowResultsHierarchyTrail.length"
      :hierarchy-trail="lowResultsHierarchyTrail"
      @click="scrollTop"
    />
    <low-results-facets
      v-if="hasFacetsFilters"
      :facet-slugs="searchFilters.facets"
      @click="scrollTop"
    />
    <low-results-dates
      v-if="isDatesSearch"
      :dates="searchFilters.dates"
      @click="scrollTop"
    />
    <low-results-price-range
      v-if="isPriceRangeSearch"
      :price-range="searchFilters.priceRange"
      @click="scrollTop"
    />
    <low-results-categories
      v-if="isCategoriesSearch"
      :categories="searchFilters.categoryIds"
      @click="scrollTop"
    />
    <low-results-bounds v-if="isBoundsSearch" @click="scrollTop" />

    <low-results-all-countries />
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { HierarchyTrail, SearchFilters } from '../../schemas'
import { isUndefined } from 'lodash-es'

@Component
class SearchLowResult extends Vue {
  @Prop()
  searchFilters: SearchFilters

  @Prop()
  hierarchyTrail: HierarchyTrail[]

  scrollTop() {
    this.$puScrollTo('[data-back-to-top]', {
      duration: 200,
    })
  }

  get isCitySearch() {
    return this.hierarchyTrail && this.hierarchyTrail?.length === 4
  }

  get cityName() {
    return this.isCitySearch ? this.hierarchyTrail[3].name : ''
  }

  get isHierarchySearch(): boolean {
    const hierarchyPath = this.searchFilters.hierarchyPath || ''
    return hierarchyPath.split('/').length > 1
  }

  get lowResultsHierarchyTrail(): HierarchyTrail[] {
    const hierarchyTrail = this.hierarchyTrail
    return hierarchyTrail
      ? hierarchyTrail.slice(0, hierarchyTrail.length - 1)
      : []
  }

  get isCategoriesSearch(): boolean {
    const categoryIds = this.searchFilters.categoryIds || []
    return !!categoryIds.length
  }

  get isDatesSearch(): boolean {
    return !!this.searchFilters.dates
  }

  get hasFacetsFilters(): boolean {
    const facets = this.searchFilters.facets || []
    return !!facets?.length
  }

  get isPriceRangeSearch(): boolean {
    const priceRange = this.searchFilters.priceRange || undefined
    return (
      (!isUndefined(priceRange?.max) && priceRange.max !== Infinity) ||
      !isUndefined(priceRange?.min)
    )
  }

  get isPointSearch(): boolean {
    return !!this.searchFilters.area && !this.searchFilters.area.isEmptyPoint
  }

  get isBoundsSearch(): boolean {
    return !!this.searchFilters.bounds
  }
}

export default toNative(SearchLowResult)
</script>

<style scoped>
section {
  background-color: #fcf6dd;
  padding: 1.4em;
  font-size: var(--body);
}

section :deep(a),
section :deep(.losenge) {
  background: #f7e8b5;
  border-radius: 0.6em;
  display: inline-block;
  margin: 0 0.5em 0.5em 0;
  padding: 0.25em 0.5em;
  text-decoration: none;
  line-height: 1.2;
}

section :deep(a + a) {
  margin-left: 0.15em;
}

section :deep(p) {
  line-height: 2;
}

/* desktop & tablet */
.low-results.desktop {
  padding: 1.4em var(--page-width-padding);
}
</style>
